import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation, AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataViewModule } from 'primeng/dataview';
import { ViewportService } from 'src/app/services/viewport.service';
import { ButtonModule } from 'primeng/button';
import { Item } from 'src/app/models/liveshop';
import { VideoModalService } from 'src/app/services/video-modal.service';
export interface VideoItem {
  uid: string;
  id: number;
  src: string;   // URL do vídeo
  poster: string; // Poster do vídeo
  thumbnail?: string;
}
@Component({
  selector: 'app-grid',
  standalone: true,
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
imports: [CommonModule, DataViewModule, ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.Emulated

})
export class GridComponent implements AfterViewInit, OnChanges {
  @Input() arraySlicksFull: Item[] = [];
  @Input() videoUrls: VideoItem[] = [];
  @Input() isAdmin: boolean = true;
  @Input() loading: boolean = false;
  @Input() isCol4: boolean = false;
  @Input() widget_id?: number | undefined;
  @Input() store_id?: number | undefined;
  @Input() height?: number | undefined;
  @Input() templateType: string | undefined;
  @Input() hasMoreVideos: boolean = true;
  @Output() loadMoreVideos = new EventEmitter<void>();
  @Output() openSidebar = new EventEmitter<void>();
  @Input() totalAssets: number = 0;
  @Input() pageToVideos: number = 0;
  @Input() instanceId?: string;

  constructor(
    private viewportService: ViewportService,
    private videoModalService: VideoModalService,
    private cdr: ChangeDetectorRef
  ) {

  }
  ngAfterViewInit(): void {
    this.viewportService.setTemplateType(this.templateType);
  }
  openModal(video: VideoItem) {
    void this.videoModalService.open({
      video,
      slicks: this.arraySlicksFull,
      totalAssets: this.totalAssets,
      isAdmin: this.isAdmin,
      widgetId: this.widget_id,
      storeId: this.store_id,
      height: this.height,
      pageToVideos: this.pageToVideos,
      instanceId: this.instanceId
    });

    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['videoUrls']) {
      this.isLoadingSlides = false;
    }
    if (changes['isCol4']) {
    }
    //this.isLoadingSlides = false;
  }

  isLoadingSlides: boolean = false;
  showbtn: boolean = true;
  loadMore() {
    this.isLoadingSlides = true;
    if (!this.loading && this.hasMoreVideos) {
      this.loadMoreVideos.emit();

    }
  }
  // Função para emitir o evento quando o botão for clicado
  onOpenSidebar(): void {
    this.openSidebar.emit();
  }

  get videoUrlsWithLoadMore() {
    if (this.hasMoreVideos) {
      return [...this.videoUrls, { isLoadMoreButton: true }];
    }
    return this.videoUrls;
  }

}
